// extracted by mini-css-extract-plugin
module.exports = {"sort":"styles_sort__1PlXR","text":"styles_text__2ZQ0p","nav":"styles_nav__1tejn","icon":"styles_icon__hTK0g","active":"styles_active__-RhAO"};